import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e0705c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-nogutter grid-header" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "column-content flex align-content-center flex-wrap h-full" }
const _hoisted_5 = {
  key: 0,
  class: "button-group"
}
const _hoisted_6 = {
  key: 1,
  class: "col text-center"
}
const _hoisted_7 = { class: "loading" }
const _hoisted_8 = {
  key: 2,
  class: "col text-center empty-result"
}

import { withDefaults, ref } from "vue";
import ProgressSpinner from "primevue/progressspinner";
import { MAX_NOTE } from "@/clinic/typings/constants/clinic";
import { set } from "@vueuse/core";

type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: any;
};

type IGridCustomer = {
  items: any[];
  columns: IColumn[];
  loading?: boolean;
  maxNote?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    items: null,
    columns: null,
    loading: { type: Boolean },
    maxNote: null
  },
  emits: ["onItemClick"],
  setup(__props: any, { emit: emits }) {

const props = __props as { items: any[], columns: IColumn[], loading?: boolean, maxNote?: number };



const showActionGroup = column => {
  return column["type"] == "action_group";
};

const sortOrders = ref({});
const sortClass = { none: "pi-sort", asc: "pi-sort-up", desc: "pi-sort-down" };
const onItemClick = (event: any, item: any) => emits("onItemClick", event, item);

const getIconClass = (column: IColumn, item: any): string | null => {
  if (column?.icon && item[column.field]) return column?.icon[item[column.field]];
  return null;
};

const onChangeSort = (column: IColumn) => {
  const currentOrder = sortOrders.value[column.field] || "none";
  let newOrder;
  switch (currentOrder) {
    case "none":
      newOrder = "asc";
      break;
    case "asc":
      newOrder = "desc";
      break;
    case "desc":
      newOrder = "asc";
      break;
  }

  // Reset sortOrders of other columns to "none"
  const updatedSortOrders = { ...sortOrders.value };
  Object.keys(updatedSortOrders).forEach(key => {
    if (key !== column.field) {
      updatedSortOrders[key] = "none";
    }
  });

  set(sortOrders, { ...updatedSortOrders, [column.field]: newOrder });
  column.sort();
};



return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`${column?.class || 'col'}`),
          style: _normalizeStyle(`${column?.style || ''}`),
          key: idx
        }, [
          _createTextVNode(_toDisplayString(column.header) + " ", 1),
          (column.sort)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["pi ml-2 cursor-pointer", sortClass[sortOrders.value[column.field] || 'none']]),
                onClick: ($event: any) => (onChangeSort(column))
              }, null, 10, _hoisted_2))
            : _createCommentVNode("", true)
        ], 6))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["grid-wrapper cursor-pointer", { 'container-scroll': props.maxNote > _unref(MAX_NOTE) }])
    }, [
      (props.items.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "grid grid-nogutter grid-content",
              key: index,
              style: _normalizeStyle(`${item?.style || ''}`)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`${column?.class || 'col'}`),
                  style: _normalizeStyle(`${column?.style || ''}`),
                  key: idx,
                  onClick: ($event: any) => (onItemClick($event, item))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, column.field, {
                      data: item,
                      index: index
                    }, () => [
                      (showActionGroup(column))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column['buttons'], (button, btnIndex) => {
                              return (_openBlock(), _createBlock(_component_Button, {
                                key: btnIndex,
                                icon: button.icons,
                                class: _normalizeClass(`${button?.class || 'grid-actions-btn mr-2'}`),
                                onClick: ($event: any) => (button.action($event, item.id))
                              }, null, 8, ["icon", "class", "onClick"]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(`${getIconClass(column, item)}`)
                          }, _toDisplayString(`${getIconClass(column, item) ? "" : item[column.field] || ""}`), 3))
                    ])
                  ])
                ], 14, _hoisted_3))
              }), 128))
            ], 4))
          }), 128))
        : (props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(ProgressSpinner), {
                  class: "loading-icon",
                  strokeWidth: "3",
                  animationDuration: ".5s"
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, "データがありません"))
    ], 2)
  ], 64))
}
}

})